export const timeStringToMinuteOfDay = (value) => {
  const trimmed = String(value || '').trim();
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(trimmed);

  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const totalMinutes = hours * 60 + minutes;

  if (totalMinutes < 0 || totalMinutes > 1439) return null;

  return totalMinutes;
};

export const minuteOfDayToTimeString = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '';

  const totalMinutes = Number(value);
  if (totalMinutes < 0 || totalMinutes > 1439) return '';

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};